import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UIState {
  /* Quick-filter input at the bottom of the sidebar; user can hide it in /settings. */
  sidebarSearchEnabled: boolean;
  setSidebarSearchEnabled: (enabled: boolean) => void;
  /* Which sidebar groups the user has collapsed, keyed by group label.
     Persisted so the layout is remembered across sessions. */
  collapsedNavGroups: Record<string, boolean>;
  toggleNavGroup: (label: string) => void;
  /* Collapse or expand a set of groups at once (sidebar "expand/collapse all"). */
  setNavGroupsCollapsed: (labels: string[], collapsed: boolean) => void;
  /* User-defined order of sidebar sections, as a list of group labels.
     Empty = default (code) order. Sections missing from the list (a module the
     user gained access to after reordering) keep their default position. */
  navGroupOrder: string[];
  setNavGroupOrder: (labels: string[]) => void;
  resetNavGroupOrder: () => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarSearchEnabled: true,
      setSidebarSearchEnabled: (enabled) =>
        set({ sidebarSearchEnabled: enabled }),
      collapsedNavGroups: {},
      toggleNavGroup: (label) =>
        set((s) => ({
          collapsedNavGroups: {
            ...s.collapsedNavGroups,
            [label]: !s.collapsedNavGroups[label],
          },
        })),
      setNavGroupsCollapsed: (labels, collapsed) =>
        set((s) => ({
          collapsedNavGroups: {
            ...s.collapsedNavGroups,
            ...Object.fromEntries(labels.map((l) => [l, collapsed])),
          },
        })),
      navGroupOrder: [],
      setNavGroupOrder: (labels) => set({ navGroupOrder: labels }),
      resetNavGroupOrder: () => set({ navGroupOrder: [] }),
    }),
    { name: "elg5-ui" },
  ),
);
